<script setup>


import {usePage, router} from "@inertiajs/vue3";
import CLink from "@/Components/CLink.vue";

const page = usePage()
const categoriesTextColor = portalOptions.categoriesTextColor

</script>

<template>
    <v-app-bar height="85" flat scroll-behavior="hide" scroll-threshold="1" color="secondary" class="category-nav-bar">
        <v-sheet max-width="100vw" color="secondary" class="mx-auto">
            <v-slide-group class="pa-4" selected-class="bg-success" show-arrows>
                <v-slide-group-item v-for="(item, index) in page.props.portalMenuItems" :key="index">
                    <div class="d-flex flex-column align-center rounded pa-4">
                        <c-link :href="route('product.list-menu', {slug: item.slug})">
                            <v-img :src="item.icon_url" height="35px" width="40px" class="mb-2 mx-auto"/>
                            <p :style="{color: categoriesTextColor}">{{ item.title }}</p>
                        </c-link>
                    </div>
                </v-slide-group-item>
            </v-slide-group>
        </v-sheet>
    </v-app-bar>
</template>

<style scoped>
/* Garantir que a barra de categorias fique abaixo do menu normal */
.category-nav-bar {
    z-index: 1004 !important;
    position: relative !important;
}

@media (max-width: 1024px) {
    .category-nav-bar {
        top: 4rem !important;
        position: relative !important;
        margin-bottom: 5%;
    }
}

@media (max-width: 768px) {
    .category-nav-bar {
        top: 4.2rem !important;
        position: relative !important;
        margin-bottom: 8%;
    }
}

@media (max-width: 430px) {
    .category-nav-bar {
        top: 4.2rem !important;
        position: relative !important;
        margin-bottom: 18%;
    }
}
</style>